import { SiriusBaseComponent } from 'sirius-framework';
import { Component, Input } from '@angular/core';
import { CommonService } from '../../service/shared.service';
import { ProcessDetail, ProcessDetailActionRequest } from '../../models/process.model';

const PROCESS_DETAIL_KEYS = {
    processDetail: 'yediEminProcessDetailProcessDetail',
    firmReference: 'yediEminProcessDetailFirmReference',
    processStatus: 'yediEminProcessDetailProcessStatus',
    productNo: 'yediEminProcessDetailProductNo',
    processAmount: 'yediEminProcessDetailProcessAmount',
    sellerDetail: 'yediEminProcessDetailSellerDetail',
    identityNo: 'yediEminProcessDetailIdentityNo',
    name: 'yediEminProcessDetailName',
    surname: 'yediEminProcessDetailSurname',
    telephoneNo: 'yediEminProcessDetailTelephoneNo',
    email: 'yediEminProcessDetailEmail',
    iban: 'yediEminProcessDetailIban',
    receiverDetail: 'yediEminProcessDetailReceiverDetail',
    receiverIdentityNo: 'yediEminProcessDetailReceiverIdentityNo',
    receiverName: 'yediEminProcessDetailReceiverName',
    receiverSurname: 'yediEminProcessDetailReceiverSurname',
    receiverTelephoneNo: 'yediEminProcessDetailReceiverTelephoneNo',
    receiverEmail: 'yediEminProcessDetailReceiverEmail',
    receiverIban: 'yediEminProcessDetailReceiverIban',
    noResultMessage: 'yediEminProcessDetailNoResultMessage',
};

const PROCESS_DETAIL_LEGACY_KEYS = {
    processDetail: 'processDetail_ProcessDetail',
    firmReference: 'processDetail_FirmReference',
    processStatus: 'processDetail_ProcessStatus',
    productNo: 'processDetail_ProductNo',
    processAmount: 'processDetail_ProcessAmount',
    sellerDetail: 'processDetail_SellerDetail',
    identityNo: 'processDetail_IdentityNo',
    name: 'processDetail_Name',
    surname: 'processDetail_Surname',
    telephoneNo: 'processDetail_TelephoneNo',
    email: 'processDetail_Email',
    iban: 'processDetail_Iban',
    receiverDetail: 'processDetail_ReceiverDetail',
    receiverIdentityNo: 'processDetail_ReceiverIdentityNo',
    receiverName: 'processDetail_ReceiverName',
    receiverSurname: 'processDetail_ReceiverSurname',
    receiverTelephoneNo: 'processDetail_ReceiverTelephoneNo',
    receiverEmail: 'processDetail_ReceiverEmail',
    receiverIban: 'processDetail_ReceiverIban',
};

@Component({
    selector: 'process-detail',
    templateUrl: './process-detail.component.html',
    styleUrls: ['./process-detail.component.css']
})
export class ProcessDetailComponent extends SiriusBaseComponent<any> {    
    @Input('ProcessRef') processRef: string;
    @Input('ProcessStatus') processStatus: string;
    @Input('IsLive') isLive: boolean;
    processDetail: ProcessDetail = null;
    noResult: boolean = false;
    TelephoneNo: string = "";
    ReceiverTelephoneNo: string = "";
    Iban: string = "";
    ReceiverIban: string = "";
    processAmount: string = "";
    isProcessDetailOpen: boolean = true;
    isSellerDetailOpen: boolean = false;
    isBuyerDetailOpen: boolean = false;
    processDetail_ProcessDetail = 'İşlem detayı';
    processDetail_FirmReference = 'İşlem referans no';
    processDetail_ProcessStatus = 'İşlem durumu';
    processDetail_ProductNo = 'Ürün no';
    processDetail_ProcessAmount = 'İşlem tutarı';
    processDetail_SellerDetail = 'Satıcı bilgileri';
    processDetail_IdentityNo = 'T.C. kimlik no';
    processDetail_Name = 'Ad';
    processDetail_Surname = 'Soyad';
    processDetail_TelephoneNo = 'Cep telefonu';
    processDetail_Email = 'E-posta';
    processDetail_Iban = 'IBAN';
    processDetail_ReceiverDetail = 'Alıcı bilgileri';
    processDetail_ReceiverIdentityNo = 'T.C. kimlik no';
    processDetail_ReceiverName = 'Ad';
    processDetail_ReceiverSurname = 'Soyad';
    processDetail_ReceiverTelephoneNo = 'Cep telefonu';
    processDetail_ReceiverEmail = 'E-posta';
    processDetail_ReceiverIban = 'IBAN';
    noResultMessage = 'Bilgi Getirilemedi';
    constructor(private commonService: CommonService) {
        super();
    }
    OnInit() {
        this.loadProcessDetailResourceStrings();
        if (this.commonService.selectedProcessDetail != null) {
            if (this.commonService.selectedProcessDetail.processRef == this.processRef) {
                this.processDetail = this.commonService.selectedProcessDetail.data as ProcessDetail;
                this.transformProcessDetail();
            }
            else {
                this.commonService.selectedProcessDetail = null;
                this.callProcessDetailService();
            }
        }
        else {
            this.callProcessDetailService();
        }     
    }
    private loadProcessDetailResourceStrings(): void {
        const r = (nk: string, lk: string, fb: string) =>
          this.commonService.getStringResourcePreferNewKey(nk, lk, fb);
        this.processDetail_ProcessDetail = r(
            PROCESS_DETAIL_KEYS.processDetail, PROCESS_DETAIL_LEGACY_KEYS.processDetail, this.processDetail_ProcessDetail);
        this.processDetail_FirmReference = r(
            PROCESS_DETAIL_KEYS.firmReference, PROCESS_DETAIL_LEGACY_KEYS.firmReference, this.processDetail_FirmReference);
        this.processDetail_ProcessStatus = r(
            PROCESS_DETAIL_KEYS.processStatus, PROCESS_DETAIL_LEGACY_KEYS.processStatus, this.processDetail_ProcessStatus);
        this.processDetail_ProductNo = r(
            PROCESS_DETAIL_KEYS.productNo, PROCESS_DETAIL_LEGACY_KEYS.productNo, this.processDetail_ProductNo);
        this.processDetail_ProcessAmount = r(
            PROCESS_DETAIL_KEYS.processAmount, PROCESS_DETAIL_LEGACY_KEYS.processAmount, this.processDetail_ProcessAmount);
        this.processDetail_SellerDetail = r(
            PROCESS_DETAIL_KEYS.sellerDetail, PROCESS_DETAIL_LEGACY_KEYS.sellerDetail, this.processDetail_SellerDetail);
        this.processDetail_IdentityNo = r(
            PROCESS_DETAIL_KEYS.identityNo, PROCESS_DETAIL_LEGACY_KEYS.identityNo, this.processDetail_IdentityNo);
        this.processDetail_Name = r(
            PROCESS_DETAIL_KEYS.name, PROCESS_DETAIL_LEGACY_KEYS.name, this.processDetail_Name);
        this.processDetail_Surname = r(
            PROCESS_DETAIL_KEYS.surname, PROCESS_DETAIL_LEGACY_KEYS.surname, this.processDetail_Surname);
        this.processDetail_TelephoneNo = r(
            PROCESS_DETAIL_KEYS.telephoneNo, PROCESS_DETAIL_LEGACY_KEYS.telephoneNo, this.processDetail_TelephoneNo);
        this.processDetail_Email = r(
            PROCESS_DETAIL_KEYS.email, PROCESS_DETAIL_LEGACY_KEYS.email, this.processDetail_Email);
        this.processDetail_Iban = r(
            PROCESS_DETAIL_KEYS.iban, PROCESS_DETAIL_LEGACY_KEYS.iban, this.processDetail_Iban);
        this.processDetail_ReceiverDetail = r(
            PROCESS_DETAIL_KEYS.receiverDetail, PROCESS_DETAIL_LEGACY_KEYS.receiverDetail, this.processDetail_ReceiverDetail);
        this.processDetail_ReceiverIdentityNo = r(
            PROCESS_DETAIL_KEYS.receiverIdentityNo, PROCESS_DETAIL_LEGACY_KEYS.receiverIdentityNo, this.processDetail_ReceiverIdentityNo);
        this.processDetail_ReceiverName = r(
            PROCESS_DETAIL_KEYS.receiverName, PROCESS_DETAIL_LEGACY_KEYS.receiverName, this.processDetail_ReceiverName);
        this.processDetail_ReceiverSurname = r(
            PROCESS_DETAIL_KEYS.receiverSurname, PROCESS_DETAIL_LEGACY_KEYS.receiverSurname, this.processDetail_ReceiverSurname);
        this.processDetail_ReceiverTelephoneNo = r(
            PROCESS_DETAIL_KEYS.receiverTelephoneNo, PROCESS_DETAIL_LEGACY_KEYS.receiverTelephoneNo, this.processDetail_ReceiverTelephoneNo);
        this.processDetail_ReceiverEmail = r(
            PROCESS_DETAIL_KEYS.receiverEmail, PROCESS_DETAIL_LEGACY_KEYS.receiverEmail, this.processDetail_ReceiverEmail);
        this.processDetail_ReceiverIban = r(
            PROCESS_DETAIL_KEYS.receiverIban, PROCESS_DETAIL_LEGACY_KEYS.receiverIban, this.processDetail_ReceiverIban);
        this.noResultMessage = this.commonService.getStringResource(PROCESS_DETAIL_KEYS.noResultMessage, this.noResultMessage);
    }
    callProcessDetailService() {
        var processDetailActionRequest: ProcessDetailActionRequest = {
            ProcessRef: this.processRef,
            IsLive: this.isLive
        }
        var promise = this.commonService.GetProcessDetail(this.dataService, processDetailActionRequest);
        promise.then((result) => {
            if (result != null) {
                this.processDetail = result as ProcessDetail;
                if (!this.processDetail.IsThereError) {                 
                    this.transformProcessDetail();
                    this.commonService.selectedProcessDetail = { processRef: this.processRef, data: this.processDetail };  
                    this.noResult = false;
                }
                else {
                    this.processDetail = null;
                    this.noResult = true;
                }             
            }
        });
    }
    transformProcessDetail() {
        this.TelephoneNo = this.GetTelephoneText(this.processDetail.TelephoneNo);
        this.ReceiverTelephoneNo = this.GetTelephoneText(this.processDetail.ReceiverTelephoneNo);
        this.Iban = this.GetIbanText(this.processDetail.Iban);
        this.ReceiverIban = this.GetIbanText(this.processDetail.ReceiverIban);
        this.processAmount = this.GetAmountText(this.processDetail.TotalAmount);
    }  
    processDetailClicked() {
        this.isProcessDetailOpen = !this.isProcessDetailOpen;
    }
    sellerDetailClicked() {
        this.isSellerDetailOpen = !this.isSellerDetailOpen;
    }

    buyerDetailClicked() {
        this.isBuyerDetailOpen = !this.isBuyerDetailOpen;
    }
    GetTelephoneText(phone: string) {
        if (phone != null && phone.trim().length == 11) {
            return phone.substr(0, 4) + " " + phone.substr(4, 3) + " " + phone.substr(7, 2) + " " + phone.substr(9, 2);
        }
        return phone;
    }
    GetIbanText(iban: string) {
        if (iban != null && iban.length > 0) {
            let ibanList = iban.match(/.{1,4}/g);
            return ibanList.join(' ');
        }
        return "";
    }
    GetAmountText(amountObject) {
        if (amountObject.Value != null && amountObject.Currency != null) {
            return amountObject.Value.toLocaleString("tr-TR") + " " + amountObject.Currency.Name;
        }
        return amountObject.Value;
    }
}
